var map = {
	"./bg-preview1.png": 405,
	"./bg-preview2.png": 8606,
	"./employees.png": 6061,
	"./homeMaskimg.png": 3304,
	"./item-null-bgi.png": 5414,
	"./logo-collapse.png": 1397,
	"./logo.png": 3153,
	"./menu-null-bgi.png": 8426,
	"./menu.png": 1617,
	"./modifier-null-bgi.png": 904,
	"./payments.png": 3581,
	"./reports.png": 5351,
	"./sub-menu-bgi.png": 4775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;